export default "__VITE_ASSET__CKxlnmjJ__"